import { Stack, Typography } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import Logo from '/assets/logo/logo_onepass.svg';
import { loginQrcode } from './OnePass.style';
import { Refresh } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { pxToRem } from '~/theme/typography';
import { v4 as uuidv4 } from 'uuid';
import { loginRoute } from '~/utils/helper/route';
import { formattedTime } from '~/utils/helper/display';
import {
  useLazyGetQrcodeTicketQuery,
  useLazyGetQrcodeTokenQuery,
} from '~/api/onePass';
import { getCookie } from '~/utils/cookie';
import { TAPIResponseStatus } from '~/api/baseFetch/common.type';
import { keyCookie } from '~/types/enum';
import { ONEPASS_STATUS } from '~/components/Login/Login.type';

const TIME_LIMIT = 300;

type TProps = {
  setStatus: (status: ONEPASS_STATUS) => void;
};

export const OnePass = ({ setStatus }: TProps) => {
  const hostId = getCookie(keyCookie.ONEPASS_HOST_ID);
  const [counter, setCounter] = useState<{ remainSeconds: number; id: string }>(
    { remainSeconds: TIME_LIMIT, id: uuidv4() },
  );
  const [getQrcodeTicket] = useLazyGetQrcodeTicketQuery();
  const [getQrcodeToken] = useLazyGetQrcodeTokenQuery();

  const qrcodeLogin = async (id: string) => {
    if (!hostId) return;
    const resTicket = await getQrcodeTicket({
      hostId,
      id,
    }).unwrap();
    if (resTicket.status !== TAPIResponseStatus.success || !resTicket.data)
      return;

    const resToken = await getQrcodeToken({
      id: counter.id,
      ticketId: resTicket.data,
    }).unwrap();

    if (resToken.data && resTicket.status === TAPIResponseStatus.success) {
      setStatus(ONEPASS_STATUS.success);
    } else {
      setStatus(ONEPASS_STATUS.ERROR);
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      if (counter.remainSeconds > 0 && hostId) {
        setCounter(prev => ({
          ...prev,
          remainSeconds: prev.remainSeconds - 1,
        }));
        void qrcodeLogin(counter.id);
      }
    }, 1000);
    return () => {
      return clearInterval(timer);
    };
  }, [counter.remainSeconds, counter.id, hostId]);

  const handleRefresh = () => {
    setCounter({ remainSeconds: TIME_LIMIT, id: uuidv4() });
  };

  return (
    <loginQrcode.container>
      <loginQrcode.counterContainer>
        <Typography
          sx={{
            fontSize: pxToRem(18),
            fontWeight: 700,
            color: 'primary.dark',
          }}
        >
          行動條碼登入
        </Typography>
        <img src={Logo} alt="行動條碼登入" width="133px" height="33px" />
        <Typography
          sx={{ display: 'flex', fontWeight: '500', fontSize: pxToRem(16) }}
          color={counter.remainSeconds > 0 ? 'text.primary' : 'error.main'}
        >
          {counter.remainSeconds > 0 ? (
            <>
              QR Code 有效期限：
              <Stack component="span" color="error.main">
                {formattedTime(counter.remainSeconds)}
              </Stack>
            </>
          ) : (
            'QR Code 已失效，請重新載入'
          )}
        </Typography>
        <loginQrcode.refreshButton onClick={handleRefresh}>
          重新產生 <Refresh sx={{ fontSize: pxToRem(16) }} />
        </loginQrcode.refreshButton>
      </loginQrcode.counterContainer>
      <Stack sx={{ padding: '10px', maxWidth: '180px', aspectRatio: '1/1' }}>
        <QRCodeSVG
          value={
            import.meta.env.VITE_ONEBOX_DOMAIN +
            loginRoute({
              id: counter.id,
            })
          }
          width="100%"
          height="100%"
        />
      </Stack>
    </loginQrcode.container>
  );
};
